import keyMirror from 'keymirror';

export const ChangePasswordActionTypes = keyMirror({
  CHANGE_PASSWORD: undefined,
  CHANGE_PASSWORD_SUCCESS: undefined,
  CHANGE_PASSWORD_ERROR: undefined,
  CHANGE_PASSWORD_CLEAR: undefined,
});
